export default __webpack_public_path__ + "static/media/phone.f78755d8.svg";